"use client";

import { cn } from "@/lib/utils";
import React from "react";
import Link from "next/link";
import HomeIcon from "@/assets/svg-icons/home";
import useActivePath from "@/hooks/useActivePath";
import SparklesIcon from "@/assets/svg-icons/sparkels";
import FeatherIcon from "@/assets/svg-icons/feather";
import GraduationCap from "@/assets/svg-icons/graduation-gap";
import { motion } from "framer-motion";
import Folder from "@/assets/svg-icons/folder-icon";

const links = [
  {
    label: "Home",
    href: "/",
    icon: HomeIcon,
  },
  {
    label: "Work",
    href: "/work",
    icon: GraduationCap,
  },
  {
    label: "Arts",
    href: "/arts",
    icon: SparklesIcon,
  },
  {
    label: "Skills",
    href: "/skills",
    icon: FeatherIcon,
  },
  {
    label: "Blog",
    href: "/blogs",
    icon: Folder,
  },
];

const Navigation = () => {
  const { isActive } = useActivePath();

  return (
    <div
      id="navigation-menu"
      className={cn(
        // Mobile Screens (default)
        "fixed bottom-4 left-1/2 z-50 h-fit -translate-x-1/2 rounded-full px-6 py-2.5 sm:bottom-8",
        "border border-border/50 bg-[#1A1B1C]/60 shadow-md backdrop-blur-md",
        // Desktop Screens
        "z-[999]",
      )}
    >
      <div className="flex flex-row gap-8">
        {links.map((link) => {
          const IconComponent = link.icon;
          const isLinkActive = isActive(link.href);

          return (
            <motion.div key={link.href} className="relative">
              <Link href={link.href}>
                <div
                  className={cn(
                    "flex flex-col items-center justify-center transition-all duration-200",
                    isLinkActive
                      ? "scale-110 text-primary"
                      : "text-muted-foreground hover:text-primary/80",
                  )}
                >
                  <IconComponent
                    className={cn("mb-0.5", isLinkActive ? "opacity-100" : "opacity-30")}
                    height="18px"
                    width="18px"
                  />
                  <span className="text-xxs font-medium">{link.label}</span>
                </div>
              </Link>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default Navigation;
